import React from 'react';
import StaticContent from 'app/blocks/static-content/static-content';

export default () => <StaticContent key="footer" hideLoadingText src="footer.html" />;
